import { createAction } from '@reduxjs/toolkit';
import { Session, SessionState } from '../../types/session';

const INIT_SESSION_STARTED = '@@SESSION_INIT_STARTED';
const INIT_SESSION_SUCCESS = '@@SESSION_INIT_SUCCESS';
const INIT_SESSION_ERROR = '@@SESSION_INIT_ERROR';

export const initSessionStarted = createAction(INIT_SESSION_STARTED);
export const initSessionSuccess = createAction<Session>(INIT_SESSION_SUCCESS);
export const initSessionError = createAction(INIT_SESSION_ERROR);

const START_SESSION_STARTED = '@SESSION_START_STARTED';
const START_SESSION_SUCCESS = '@SESSION_START_SUCCESS';
const START_SESSION_FAILURE = '@SESSION_START_ERROR';

export const startSessionStarted = createAction(START_SESSION_STARTED);
export const startSessionSuccess = createAction<SessionState>(START_SESSION_SUCCESS);
export const startSessionError = createAction(START_SESSION_FAILURE);
